// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"96":"FlightAttendantCartaRenuncia","499":"ThanksView"}[chunkId] + "." + {"96":"2801bd75","499":"30bc1d8e"}[chunkId] + ".css";
};